// extracted by mini-css-extract-plugin
export default {"recos":"W_-z","productCardOverride":"X_-z","rowHasBadge":"Y_-z"};